import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M4.47 7.97a.75.75 0 011.06 0L12 14.44l6.47-6.47a.75.75 0 111.06 1.06l-7 7a.75.75 0 01-1.06 0l-7-7a.75.75 0 010-1.06" clipRule="evenodd" /></svg>;